<template>
    <div>
        <div class="row">
            <div class="col-12 rounded m-b-10">
                <b-card bg-variant="light" text-variant="dark">
                    <b-row no-gutters>
                        <b-col md="4" class="text-center">
                            <b-card-img 
                                :src="getImage(currentItem.image)" 
                                alt="Storyboard image"
                                width="100%" 
                                style="max-width:256px; max-height:256px;"
                            />
                        </b-col>
                        <b-col md="8" class="d-flex">
                            <div class="my-auto m-l-10">
                                <b-card-title>{{ currentItem.name }}</b-card-title>
                                <b-card-text>
                                    <div class="f-s-14 m-b-5">
                                        <b>Description:</b> {{ currentItem.description ? currentItem.description : "-" }}<br/>
                                        <b>Insights:</b> {{ currentItem.insights ? currentItem.insights : "-" }}<br/>
                                        <b>Target outcome:</b> {{ currentItem.target ? currentItem.target : "-" }}<br/>
                                        <b>Responsible person:</b> {{ currentItem.responsiblePerson ? currentItem.responsiblePerson : "-" }}<br/>
                                        <b>Production budget:</b> {{ currentItem.budget ? `${currentItem.budget} €` : "-" }}<br/>
                                    </div>
                                    <div class="f-s-14">
                                        <b>Stages:</b> {{ currentItem.stages.length }}<br/>
                                        <b>Steps:</b> {{ storyboardSteps.length }}<br/>
                                        <b>Active items:</b> {{ getItemActiveItems(currentItem) }}<br/>
                                    </div>
                                </b-card-text>
                            </div>
                        </b-col>
                    </b-row>
                </b-card>
            </div>
        </div>
        <div class="row" v-if="!exportMode">
            <div class="col-xl-6 m-b-10">
                <b-card header-tag="header" header-bg-variant="dark" header-text-variant="light">
                    <template v-slot:header>
                        <h6 class="mb-0">Storyboard files</h6>
                    </template>
                    <b-card-text>
                        <vue-custom-scrollbar style="height:150px">
                            <div class="row">
                                <div class="m-20 text-center" v-for="file in currentItem.files" :key="file.id">
                                    <a :href="fileUrl + file.fileFd" :download="file.fileFd">
                                        <i v-if="fileType(file.fileFd) == 'pdf'" class="fas fa-file-pdf fa-5x" />
                                        <i v-else-if="fileType(file.fileFd) == ('jpg' || 'jpeg')" class="fas fa-file-image fa-5x" />
                                        <p class="text-black">{{ file.name }}</p>
                                    </a>
                                </div>
                            </div>
                            <div v-if="!currentItem.files.length">
                                <p class="m-l-10">No files</p>
                            </div>
                        </vue-custom-scrollbar>
                    </b-card-text>
                </b-card>
            </div>
            <div class="col-xl-6">
                <b-card header-tag="header" header-bg-variant="dark" header-text-variant="light">
                    <template v-slot:header>
                        <h6 class="mb-0">Storyboard notes</h6>
                    </template>
                    <b-card-text>
                        <vue-custom-scrollbar style="height:150px">
                            <ul class="media-list media-list-with-divider media-messaging">
                                <li class="media media-sm" v-for="(note, index) in currentItem.notes" :key="note.id">
                                    <div class="media-body">
                                        <h5 class="media-heading">Note #{{ index + 1 }}</h5>
                                        <p>{{ note.content }}</p>
                                    </div>
                                </li>
                                <li v-if="!currentItem.notes.length" class="media media-sm">
                                    <div class="media-body">
                                        <p>No notes</p>
                                    </div>
                                </li>
                            </ul>
                        </vue-custom-scrollbar>
                    </b-card-text>
                </b-card>
            </div>
        </div>
        <div class="row">
            <div class="col-12 rounded p-t-5">
                <div class="bg-white rounded border p-15 p-t-5 p-b-5 m-b-10" v-if="storyboardSteps.length">
                    <task-stage-modal-content 
                        v-for="(stage, index) in storyboardStages"
                        :key="stage.id"
                        :categories="categories" 
                        :items="items" 
                        :stageNumber="`Storyboard stage ${index + 1}/${currentItem.stages.length}`" 
                        :currentItem="stage" 
                        :filterStepScriptItems="filterStepScriptItems" 
                        :getTypeName="getTypeName" 
                        :setItemTitle="setItemTitle"
                        :getItemActiveItems="getItemActiveItems"
                        :exportMode="exportMode"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import TaskStageModalContent from '../task/TaskStageModalContent.vue'

export default {
    props: [
        'categories',
        'items', 
        'currentItem', 
        'filterStepScriptItems', 
        'getTypeName', 
        'setItemTitle', 
        'getItemActiveItems',
        'storyboardSteps',
        'storyboardStages',
        'exportMode'
    ],
    data() {
        return {
            fileUrl: process.env.VUE_APP_API_URL + '/uploads/files/'
        }
    },
    components: {
        TaskStageModalContent
    },
    methods: {
        getImage(image) {
            if (image == null) {
                return require('../../assets/images/no_image.jpg');
            } else {
                return process.env.VUE_APP_API_URL + '/uploads/images/' + image.imageFd;
            }
        },
        fileType(path) {
           return path.slice(path.lastIndexOf('.') + 1);
        },
    }
}
</script>